import { render, staticRenderFns } from "./SendTicketModal.vue?vue&type=template&id=5558f081"
import script from "./SendTicketModal.vue?vue&type=script&lang=js"
export * from "./SendTicketModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports